import React, { useEffect, useRef, useState } from "react";
import EquipoModeloService from "../../../services/ListaVerificacion/EquipoModeloService";
import { ITableModeloEquipo } from "../../../Interfaces/ListaVerificacion/ModeloEquipo/IModeloEquipo";
import { ISearchBox } from "@fluentui/react";
import {
  IPaginacion,
  Ifilter,
  InitialFilter,
} from "../../../Interfaces/filter";
import { IException } from "../../../Interfaces/base/IBase";

export const useAsignacionEquipos = () => {
  const [item, setItems] = useState<ITableModeloEquipo[]>([]);
  const [filterTable, setFilterTable] = useState<Ifilter>(InitialFilter);
  const [paginacion, setPaginacion] = useState<IPaginacion>(null!);
  const [loading, setLoading] = useState(false);

  const searchBoxRefTable = useRef<ISearchBox>(null);
  const _onkeyUpSearchModeloEquipo = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilterTable({ ...filterTable, search: value });
  };
  const onClickNext = () => {
    let valueSkip = filterTable.skip;
    setFilterTable({ ...filterTable, skip: valueSkip + 1 });
  };

  const onClickPrevius = () => {
    let valueSkip = filterTable.skip;
    setFilterTable({ ...filterTable, skip: valueSkip - 1 });
  };

  function postModeloEquipos() {
    setLoading(true);
    EquipoModeloService.PostTableEquipoModelo(filterTable)
      .then((res) => {
        if (res.status === 200) {
          console.log("eseta es la data de la tabla", res.data);
          setItems(res.data.items);
          setPaginacion({
            page: res.data.page,
            pages: res.data.pages,
            total: res.data.total,
          });
          setLoading(false);
        } else {
          setLoading(true);
        }
      })
      .catch((err: IException) => {
        setLoading(false);
      });
  }
  const onClickRefresh = () => {
    if (filterTable.search !== "") {
      setFilterTable(InitialFilter);
    } else {
      postModeloEquipos();
    }
  };
  const onChangeSkip = (evento: string) => {
    switch (evento) {
      case "next":
        setFilterTable({ ...filterTable, skip: filterTable.skip + 1 });
        break;
      case "prev":
        setFilterTable({ ...filterTable, skip: filterTable.skip - 1 });
        break;

      default:
        break;
    }
  };

  useEffect(() => {
    postModeloEquipos();
  }, [filterTable]);

  return {
    loading,
    onClickRefresh,
    item,
    paginacion,
    searchBoxRefTable,
    _onkeyUpSearchModeloEquipo,
    onChangeSkip
  };
};
